export default class LegacyTabModel {
  public RaceNo!: number
  public Sel!: string
  public AllUpBetType!: string
}
